<hlm-popover align="end" class="theme-selector" (stateChanged)="onStateChanged($event)">
  <button
    type="button"
    hlmPopoverTrigger
    class="theme-selector__trigger"
    [attr.aria-label]="
      ('theme.change-color-scheme' | translate) + ': ' + (currentLabelKey | translate)
    "
    [attr.title]="('theme.change-color-scheme' | translate) + ': ' + (currentLabelKey | translate)"
    [attr.aria-expanded]="isPopoverOpen()"
    [attr.aria-controls]="popoverId"
    aria-haspopup="menu"
  >
    <ocp-themed-icon [name]="currentIconName" class="theme-selector__icon" />
  </button>

  <hlm-popover-content *hlmPopoverPortal="let ctx" class="w-fit">
    <div
      [id]="popoverId"
      class="theme-selector__options"
      role="menu"
      [attr.aria-label]="'theme.select-theme' | translate"
    >
      @for (option of themeOptions; track option.mode) {
        <button
          type="button"
          class="theme-selector__option"
          [class.theme-selector__option--active]="themeMode() === option.mode"
          role="menuitemradio"
          [attr.aria-checked]="themeMode() === option.mode"
          [attr.aria-label]="option.labelKey | translate"
          (click)="onSelectTheme(option.mode, ctx)"
        >
          @if (themeMode() === option.mode) {
            <ocp-themed-icon name="checkmark.svg" class="theme-selector__option-check" />
          } @else {
            <span class="theme-selector__option-check-placeholder"></span>
          }
          <ocp-themed-icon [name]="option.iconName" class="theme-selector__option-icon" />
          <span class="theme-selector__option-label">{{ option.labelKey | translate }}</span>
        </button>
      }
    </div>
  </hlm-popover-content>
</hlm-popover>
